// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabs_tab__3pFRp","tabActive":"tabs_tabActive__2802X"};